// const API_AUTH_USERNAME = import.meta.env.VITE_REACT_APP_API_AUTH_USERNAME;
// const API_AUTH_PASSWORD = import.meta.env.VITE_REACT_APP_API_AUTH_PASSWORD;
// const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_URL;
const API_AUTH_USERNAME = "";
const API_AUTH_PASSWORD = "";
const API_BASE_URL = "";

const ADMIN_ID = "1";
const MOBILE_NUMBER = "8080335613";
const MOBILE_NUMBER2 = "7507776426";
const EMAIL_ADDRESS = "sales@surftechsystems.com";
const EMAIL_ADDRESS2 = "svi@surftechsystems.com";
const COMPANY_NAME = "Paint Booth Manufacturers In Pune";
const ADDRESS = `801, Warje Business Bay, Sr.No.131/2A/1/1&13, Pune, MH-411058 India`;
const ADDRESS2 = `Shed No.5, GAT No.33, Pune-Bangalore Highway, Behind Jagdamba Hotel, Shriramnagar, Khed Shivapur, Pune, MH-412205 India`;

const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=100064003628831";
const GOOGLE_URL =
  "https://www.google.com/search?q=Surftechsystems+India+Private+Limited+(Paint+Booth/Powder+Coating+Plant/Industrial+Oven/Shot+Blasting+System+Manufacturer)&stick=H4sIAAAAAAAA_x3MTQrCMBBA4ZXiMQZB0FUTo_VnqStBMdATTNqJDbQJJNNaPY4ntXT_vbeYL1diUKbcnvZHtZdWiNyYsxhye1CkyOyUzaWR8jf7Fl20TGWdPompTXDzlUPQ0fXIBHfXOqYK1hqdZ7iEwHWmw7uiCNeA7PwLdIOes7HrEkeHDTx78llRh9E3mCZTTHd4oO8sltxFips_6X-qiaYAAAA&hl=en&mat=CaOOzYSViyKyElcBqiIDwi54f1oH5BqcoGK2itz69z3NUcscRJda_pkRPLafEeoVw13Ze4rc1vE4DACzAt6e_NhoAPaZUvYEkq1MYZl5Z9GRoY7rDany7M70rDRZdzRwONI&authuser=0";
// const INSTAGRAM_URL = "https://www.instagram.com/mohite_pcb/";
const YOUTUBE_URL = "https://www.youtube.com/channel/UCrKYjhNJZ9hC30WphIbA2qA";
const LINKEDIN_URL = "https://www.linkedin.com/in/somnath-ingale/";

const PROJECT_NAME = "Paint Booth Manufacturers In Pune";
const PROJECT_NAME_SEO = "Paint Booth Manufacturers In Pune";
// const PROJECT_NAME_SEO = "Surftech System PVT.LTD";

const MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4528.4362035965905!2d73.7870826758277!3d18.466745470814974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2958351f006bb%3A0x6f73e3eb43f61b11!2sSurftechsystems%20India%20Private%20Limited%20(Paint%20Booth%2FPowder%20Coating%20Plant%2FIndustrial%20Oven%2FShot%20Blasting%20System%20Manufacturer)!5e1!3m2!1sen!2sin!4v1740131415065!5m2!1sen!2sin";

export {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
  ADMIN_ID,
  MOBILE_NUMBER,
  EMAIL_ADDRESS,
  MOBILE_NUMBER2,
  EMAIL_ADDRESS2,
  ADDRESS,
  ADDRESS2,
  COMPANY_NAME,
  YOUTUBE_URL,
  LINKEDIN_URL,
  PROJECT_NAME,
  MAP_URL,
  PROJECT_NAME_SEO,
  FACEBOOK_URL,
  GOOGLE_URL,
};
